import { ButtonBase } from '../../../Button/ButtonBase';
import { InnerButtonAreaTwoColumns } from '../../../Layout/InnerLayout/InnerButtonAreaTwoColumns';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { CancelMembershipAttribute } from '../../../../types/CancelMembershipAttribute';
import type { FC, FormEventHandler } from 'react';

export type CancelMembershipConfirmContentsProps = {
  cancelMemberElements: CancelMembershipAttribute;
};

const onSubmit: FormEventHandler<HTMLFormElement> = (event) =>
  event.preventDefault();

export const CancelMembershipConfirmContents: FC<
  CancelMembershipConfirmContentsProps
> = ({ cancelMemberElements }) => (
  <form method="post" onSubmit={onSubmit}>
    <TableBody>
      <TableTrFormLabel
        id="email"
        required={true}
        title="登録しているメールアドレス"
      >
        {cancelMemberElements.loggedInUser.email}
      </TableTrFormLabel>
      <TableTrFormLabel id="reason" required={false} title="退会理由">
        {cancelMemberElements.reason}
      </TableTrFormLabel>
    </TableBody>

    <InnerButtonAreaTwoColumns>
      <ButtonBase
        color="secondary"
        width="wide"
        onClick={cancelMemberElements.eventHandlers.onClickBackButton}
      >
        戻る
      </ButtonBase>
      <ButtonBase
        color="primary"
        width="wide"
        onClick={
          cancelMemberElements.eventHandlers.onClickCancelMembershipButton
        }
      >
        退会する
      </ButtonBase>
    </InnerButtonAreaTwoColumns>
  </form>
);
